import { render, staticRenderFns } from "./AlertSettingEdit.vue?vue&type=template&id=ed011344&scoped=true"
import script from "./AlertSettingEdit.vue?vue&type=script&lang=js"
export * from "./AlertSettingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed011344",
  null
  
)

export default component.exports